"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prefixRoutes = prefixRoutes;
exports.renderRoutes = renderRoutes;
exports.sanitizeRouteParams = sanitizeRouteParams;
exports.connectRouter = connectRouter;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _trimStart2 = _interopRequireDefault(require("lodash/trimStart"));
var _flatten2 = _interopRequireDefault(require("lodash/flatten"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _reactRouterDom = require("react-router-dom");
var _UnexpectedCaseException = _interopRequireDefault(require("../core/exceptions/UnexpectedCaseException"));
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function prefixPath(prefix, path) {
  return Array.isArray(path) ? path.map(prefixPath.bind(null, prefix)) : prefix + path;
}
function prefixPathTrimSlash(prefix, path) {
  return Array.isArray(path) ? path.map(prefixPathTrimSlash.bind(null, prefix)) : prefix + (0, _trimStart2.default)(path, '/');
}
function prefixRoutes(prefix, routes) {
  var prefixFn = prefix.substr(-1) === '/' ? prefixPathTrimSlash : prefixPath;
  return (0, _flatten2.default)(routes).map(function (route) {
    return _objectSpread({}, route, {
      path: prefixFn(prefix, route.path)
    });
  });
}
function renderRoutes(_ref, routes) {
  var handler = _ref.handler,
    auth = (0, _objectWithoutProperties2.default)(_ref, ["handler"]);
  var effHandler = handler || function (_ref2, _ref3) {
    var render = _ref2.render;
    var params = _ref3.params;
    return render(params);
  };
  return (0, _flatten2.default)(routes).map(function (route, index) {
    var availability = route.isEnabled ? route.isEnabled(auth) : true;
    return _react.default.createElement(_reactRouterDom.Route, {
      key: route.id || index,
      path: route.path,
      exact: !route.isPrefix,
      render: function render(_ref4) {
        var match = _ref4.match;
        if (availability) {
          return effHandler(route, match, auth);
        }
        if (!auth.isUser) {
          return _react.default.createElement(_reactRouterDom.Redirect, {
            to: "/login/"
          });
        }
        return _react.default.createElement(_reactRouterDom.Redirect, {
          to: "/"
        });
      }
    });
  });
}
var falsyParams = new Set(['no', 'false']); // @see allowedChars at https://www.npmjs.com/package/transliteration

var safeIdRegExp = /^[a-zA-Z0-9-_.~']+$/;
function sanitizeRouteParams(params, definition) {
  var defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _mapValues2.default)(definition, function (type, key) {
    var value = params[key];
    if ((0, _isFunction2.default)(type)) {
      return type(value);
    }
    var isOptional = type.substr(0, 1) === '?';
    if (isOptional && value == null) {
      return defaults[key] || null;
    }
    var plainType = isOptional ? type.substr(1) : type;
    switch (plainType) {
      case 'id':
        return safeIdRegExp.test(value) ? value : '';
      // TODO: Throw BadRequest somehow

      case 'string':
        return String(value);
      case 'number':
        return parseFloat(value);
      case 'int':
        return parseInt(value, 10);
      case 'boolean':
        if (!value) return false;
        return !(value in falsyParams);
      default:
        throw new _UnexpectedCaseException.default();
    }
  });
}
function connectRouter() {
  return (0, _reactRedux.connect)(function (_ref5) {
    var authState = _ref5.auth.state;
    return {
      isUser: authState.status === 'user',
      isGuest: authState.status === 'guest',
      authState: authState
    };
  });
}